import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BorderouComponent } from './borderou.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToateTabelBorderouComponent } from './toate-tabel-borderou/toate-tabel-borderou.component';
import { AddBorderouComponent } from './add-borderou/add-borderou.component';
import { ModificareAvizOrarComponent } from './modificare-aviz-orar/modificare-aviz-orar.component';
import { AcordFunctionareComponent } from './acord-functionare/acord-functionare.component';
import { AcordTemporarTeraseComponent } from './acord-temporar-terase/acord-temporar-terase.component';
import { AcordTemporarToateComponent } from './acord-temporar-toate/acord-temporar-toate.component';
import { AlimentatiePublicaComponent } from './alimentatie-publica/alimentatie-publica.component';
import { AutorizatieTargPiataComponent } from './autorizatie-targ-piata/autorizatie-targ-piata.component';
import { PrelungireAcorduriFunctionareComponent } from './prelungire-acorduri-functionare/prelungire-acorduri-functionare.component';
import { RecreativeComponent } from './recreative/recreative.component';
import { AcordComercializareComponent } from './acord-comercializare/acord-comercializare.component';
import { AcordTeraseSezoniereComponent } from './acord-terase-sezoniere/acord-terase-sezoniere.component';

@NgModule({
  declarations: [BorderouComponent, ToateTabelBorderouComponent, AddBorderouComponent, ModificareAvizOrarComponent, AcordFunctionareComponent, AcordTemporarTeraseComponent, AcordTemporarToateComponent, AlimentatiePublicaComponent, AutorizatieTargPiataComponent, PrelungireAcorduriFunctionareComponent, RecreativeComponent, AcordComercializareComponent, AcordTeraseSezoniereComponent],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports: [BorderouComponent]
})
export class BorderouModule { }
